import { render, staticRenderFns } from "./MenuSelectbox.vue?vue&type=template&id=baac9a68"
import script from "./MenuSelectbox.vue?vue&type=script&lang=js"
export * from "./MenuSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports